import { db } from './config';
import { collection, addDoc, getDocs, doc, deleteDoc, query, orderBy, updateDoc } from 'firebase/firestore';

const COLLECTION_NAME = 'contactMessages';

// Save a new contact message
export const saveContactMessage = async (messageData) => {
  try {
    const newMessage = {
      ...messageData,
      createdAt: new Date().toISOString(),
      read: false
    };
    
    const docRef = await addDoc(collection(db, COLLECTION_NAME), newMessage);
    return { id: docRef.id, ...newMessage };
  } catch (error) {
    console.error('Error saving contact message:', error);
    throw error;
  }
};

// Get all contact messages
export const getContactMessages = async () => {
  try {
    const messagesCollection = collection(db, COLLECTION_NAME);
    const messagesQuery = query(messagesCollection, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(messagesQuery);
    
    const messages = [];
    querySnapshot.forEach((doc) => {
      messages.push({ id: doc.id, ...doc.data() });
    });
    
    return messages;
  } catch (error) {
    console.error('Error retrieving contact messages:', error);
    return [];
  }
};

// Mark message as read
export const markMessageAsRead = async (id, isRead = true) => {
  try {
    const messageRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(messageRef, { 
      read: isRead,
      updatedAt: new Date().toISOString() 
    });
    
    return { id, read: isRead };
  } catch (error) {
    console.error('Error updating message read status:', error);
    throw error;
  }
};

// Delete a contact message
export const deleteContactMessage = async (id) => {
  try {
    const messageRef = doc(db, COLLECTION_NAME, id);
    await deleteDoc(messageRef);
    return id;
  } catch (error) {
    console.error('Error deleting contact message:', error);
    throw error;
  }
};